// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d011792a58994c7e5af5","655":"39c036886da6b02c20a5"}[chunkId] + ".js";
};